<div
  *ngIf="header.title !== ''"
  class="p-4 flex justify-between items-center"
  [ngClass]="{
    'pt-4 px-4': !header.showBorder,
    'p-4 border-b-2 border-gray-20': header.showBorder
  }"
>
  <div [ngClass]="header.icon ? 'header-with-icon' : ''">
    <div *ngIf=header.icon><img [src]="header.icon" class="header-icon" alt=""></div>
    <h5 class="text-black-800 text-lg font-inter-bold" [ngClass]="header.isRed ? 'text-red' : ''">{{ header.title }}</h5>
  </div>
  <button
    *ngIf="header.showClose"
    mat-dialog-close
    class="close-btn"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
